import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { LiquidTemplate } from "@/types";
import { fetchLiquidTemplates } from "./thunk";

export interface LiquidTemplatesState {
  liquidTemplates: Partial<LiquidTemplate[]>;
  error: string | null;
  status: "idle" | "fetching" | "saving";
}

const initialState: LiquidTemplatesState = {
  liquidTemplates: [],
  error: null,
  status: "idle"
};

export const liquidTemplatesSlice = createSlice({
  name: "liquidTemplates",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[liquidTemplatesSlice.name]
        };
      })
      .addCase(fetchLiquidTemplates.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchLiquidTemplates.fulfilled, (state, action) => {
        state.status = "idle";
        state.liquidTemplates = action.payload;
      })
      .addCase(fetchLiquidTemplates.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      });
  }
});
